import { provider } from '@/provider.js'
import Vue from "vue"

export default {
  state: {
    all: [],
    current: {
      team: { users: [] }
    }
  },
  mutations: {
    setTeams(state, teams) {
      state.all = teams
    },
    addTeam(state, team) {
      Vue.set(state, 'all', [...state.all, team]);
    },
    clearTeam(state) {
      state.current.team = {}
    },
    setTeam(state, team) {
      state.current.team = team
    },
    setTeamAssignedTasks(state, teams) {
      Vue.set(state, 'all', teams);
    },
    createTeamMembership(state, { allUsers, userId }) {
      const user = allUsers.find(user => user.id === userId)
      state.current.team.users.push(user)
      Vue.set(state.current.team, 'users', [...state.current.team.users])
    },
    deleteTeamMembership(state, { teamId, userId }) {
      if (state.current && state.current.team && state.current.team.id === teamId) {
        const teamMembers = state.current.team.users
        const userIndex = teamMembers.findIndex(user => user.id === userId)
        if (userIndex >= 0) {
          teamMembers.splice(userIndex, 1)
          Vue.set(state.current.team, 'users', [...teamMembers])
        }
      }
    }
  },
  actions: {
    async createTeam({commit}, team) {
      const response = await provider.createTeam(team)
      if (response.error) {
        commit("displayFlashMessage", { message: response.message, severity: "error" })
      } else {
        commit("addTeam", response.team)
        Vue.router.push({name: "Teams"})
      }
    },
    async updateTeam(_, data) {
      return await provider.updateTeam(data)
    },
    async deleteTeamMembership({ commit, rootState }, { teamId, userId }) {
      const allTeams = rootState.teams.all
      const allUsers = rootState.users.all
      const response = await provider.deleteTeamMembership({ teamId, userId })
      if (response.error) {
        commit("displayFlashMessage", { message: response.message, severity: "error" })
      } else {
        commit("deleteTeamMembership", { teamId, userId, allTeams, allUsers })
      }
    },
    async createTeamMembership({ commit, rootState }, { teamId, userId }) {
      const allTeams = rootState.teams.all
      const allUsers = rootState.users.all
      const response = await provider.createTeamMembership({ teamId, userId })
      if (response.error) {
        commit("displayFlashMessage", { message: response.message, severity: "error" })
      } else {
        commit("createTeamMembership", { teamId, userId, allTeams, allUsers })
      }
    },
    async deleteTeam(_, team) {
      return await provider.deleteTeam(team.id)
    },
    setCurrentTeam({ commit, state }, teamId) {
      const team = state.all.find(team => team.id === teamId)
      commit("setTeam", team)
    }
  }
}
